// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/compare/compare.css
// module id = 1535
// module chunks = 0